import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import SupplementResponseStatusDot from '@components/SupplementResponseStatusDot/SupplementResponseStatusDot';
import { IMedicationResponse } from '@interfaces/medications';
import { TSupplementResponseStatus } from '@interfaces/supplements';

import './style.scss';

export interface IProps {
  data: IMedicationResponse;
  isSelected: boolean;
  className?: string;
  onShowDetails: (data: IMedicationResponse) => void;
}

const MedicationResponseCard: FC<IProps> = ({ className, data, isSelected, onShowDetails }) => {
  const { t } = useTranslation();

  const handleShowDetails = useCallback(() => {
    onShowDetails(data);
  }, [onShowDetails, data]);

  if (!data) {
    return null;
  }

  return (
    <div
      className={cn(
        'medication-response-card',
        { 'medication-response-card_active': isSelected },
        className,
      )}
    >
      {/* Separate clickable card surface to avoid event collisions with clickable risk level button below */}
      <div className="medication-response-card__surface" onClick={handleShowDetails} />
      <div className="medication-response-card__name">{data.name}</div>
      {data.supplementInquiryStatusId !== TSupplementResponseStatus.Complete && (
        <SupplementResponseStatusDot
          className="medication-response-card__status"
          value={data.supplementInquiryStatusId}
        />
      )}
    </div>
  );
};

export default MedicationResponseCard;
